/* global google */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, withProps, lifecycle } from 'recompose';
import { Map } from 'immutable';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';
import ObjectSearchMapLabel from './ObjectSearchMapLabel';
import MarkerWithLabel from 'react-google-maps/lib/components/addons/MarkerWithLabel';
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer';
import CustomMarkerIconLokaler from '../../assets/map_marker_blue.svg';
import CustomMarkerIconBostader from '../../assets/map_marker_green.svg';
import CustomClusterIconLokaler from '../../assets/map_cluster_blue.svg';
import CustomClusterIconBostader from '../../assets/map_cluster_green.svg';
import CustomClusterIconLokaler2 from '../../assets/map_cluster_marker_blue_2.svg';
import CustomClusterIconLokaler3 from '../../assets/map_cluster_marker_blue_3.svg';
import CustomClusterIconLokaler4 from '../../assets/map_cluster_marker_blue_4.svg';
import CustomClusterIconLokaler5 from '../../assets/map_cluster_marker_blue_5.svg';
import CustomClusterIconLokaler6 from '../../assets/map_cluster_marker_blue_6.svg';
import TransparentMarker from '../../assets/map_transparent_marker.svg';
import './ObjectSearchMap.css';
const gmapkey = 'AIzaSyAKeoD9mdKFjcmMa-ET8TxRGRh1woNyWx0';

const GMap = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?v=quarterly&libraries=geometry,drawing,places&key=${gmapkey}`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `100%` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  lifecycle({
    UNSAFE_componentWillMount() {
      const refs = {};

      this.setState({
        bounds: null,
        onMapMounted: (ref) => {
          refs.map = ref;
        },
        onBoundsChanged: (e) => {
          return this.props.onBoundsChanged(refs.map.getBounds());
        },
        onZoomChanged: (e) => {
          return this.props.onZoomChanged(refs.map.getZoom());
        },
        onSearchChanged: (e) => {
          try {
            if (typeof google === 'undefined') {
              return;
            }
            const bounds = new google.maps.LatLngBounds();
            let latitude;
            let longitude;

            if (this.props.objectData.size) {
              this.props.objectData.forEach((place) => {
                latitude = place.getIn(['geolocation', 'latitude']);
                longitude = place.getIn(['geolocation', 'longitude']);

                if (latitude && longitude) {
                  bounds.extend({ lat: latitude, lng: longitude });
                }
              });

              refs.map && refs.map.fitBounds(bounds);
            } else {
              bounds.extend({ lat: 54.826, lng: 10.656 });
              bounds.extend({ lat: 69.099, lng: 24.455 });
              refs.map && refs.map.fitBounds(bounds);
            }
          } catch (e) {
            console.warn('ERROR : ', e);
            throw new Error(e);
          }
        },
      });
    },
    componentDidUpdate(nextProps, nextState) {
      if (nextProps.objectData !== this.props.objectData) {
        this.state.onSearchChanged();
      }
    },
    componentDidMount() {
      // TODO: make something nicer, setTimeout() is not ideal...
      setTimeout(() => {
        this.state.onSearchChanged();
      }, 500);
    },
  }),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap
    ref={props.onMapMounted}
    defaultZoom={5}
    defaultCenter={props.center}
    onBoundsChanged={props.onBoundsChanged}
    center={props.center}
    onSearchChanged={props.onSearchChanged}
    onZoomChanged={props.onZoomChanged}
    // This breaks clicking on labels on mobile, disabled while working on a workaround...
    /*onClick={() => {
            	props.selectObject(null);
			}}*/
  >
    <MarkerClusterer
      averageCenter
      enableRetinaIcons
      gridSize={40}
      maxZoom={14}
      zoomOnClick={true}
    >
      {props.objectGroupsWithSameLocations &&
        props.objectGroupsWithSameLocations.map((cluster, index) => {
          const marker = cluster.filter(
            (item) => item.get('id') === props.selectedObject.id
          ).size
            ? cluster
                .filter((item) => item.get('id') === props.selectedObject.id)
                .get(0)
            : cluster.get(0);
          let latitude = marker.getIn(['geolocation', 'latitude']);
          let longitude = marker.getIn(['geolocation', 'longitude']);

          if (latitude && longitude) {
            // Dynamically set marker icon based on cluster size
            let markerIcon = '';
            switch (cluster.size) {
              case 2:
                markerIcon = CustomClusterIconLokaler2;
                break;
              case 3:
                markerIcon = CustomClusterIconLokaler3;
                break;
              case 4:
                markerIcon = CustomClusterIconLokaler4;
                break;
              case 5:
                markerIcon = CustomClusterIconLokaler5;
                break;
              default:
                markerIcon = CustomClusterIconLokaler6;
                break;
            }

            return (
              <MarkerWithLabel
                key={index}
                icon={{
                  url:
                    props.theme === 'bostader'
                      ? CustomClusterIconBostader
                      : markerIcon,
                }}
                position={{ lat: latitude, lng: longitude }}
                labelAnchor={new google.maps.Point(121, 195)}
                labelVisible={props.selectedObject.id === marker.get('id')}
                onClick={(e) => {
                  // TODO: find a way to clean up this onClick function... - AJ
                  const currentIndex = cluster.findIndex(
                    (marker) => marker.get('id') === props.selectedObject.id
                  );

                  if (e instanceof Event && e.target.nodeName === 'A') {
                    window.location.href = marker.get('url');
                  } else if (
                    e instanceof Event &&
                    e.target.dataset.nextObject
                  ) {
                    if (currentIndex >= cluster.size - 1) {
                      return props.selectObject(cluster.get(0).get('id'), true);
                    } else {
                      return props.selectObject(
                        cluster
                          .get(
                            cluster.findIndex(
                              (marker) =>
                                marker.get('id') === props.selectedObject.id
                            ) + 1
                          )
                          .get('id'),
                        true
                      );
                    }
                  } else if (
                    e instanceof Event &&
                    e.target.dataset.prevObject
                  ) {
                    if (currentIndex <= 0) {
                      return props.selectObject(
                        cluster.get(cluster.size - 1).get('id'),
                        true
                      );
                    } else {
                      return props.selectObject(
                        cluster
                          .get(
                            cluster.findIndex(
                              (marker) =>
                                marker.get('id') === props.selectedObject.id
                            ) - 1
                          )
                          .get('id'),
                        true
                      );
                    }
                  } else {
                    return props.selectObject(marker.get('id'), true);
                  }
                }}
                noRedraw={true}
              >
                <ObjectSearchMapLabel
                    theme={props.theme}
                    selectedObject={props.selectedObject}
                    marker={marker}
                    cluster={cluster}
                />
              </MarkerWithLabel>
            );
          } else {
            return null;
          }
        })}
      {props.objectWithUniqueLocation &&
        props.objectWithUniqueLocation.map((marker, index) => {
          let latitude = marker.getIn(['geolocation', 'latitude']);
          let longitude = marker.getIn(['geolocation', 'longitude']);

          if (latitude && longitude) {
            return (
              <MarkerWithLabel
                key={index}
                icon={{
                  url:
                    props.theme === 'bostader'
                      ? props.selectedObject.id === marker.get('id')
                        ? CustomClusterIconBostader
                        : CustomMarkerIconBostader
                      : props.selectedObject.id === marker.get('id')
                      ? CustomClusterIconLokaler
                      : CustomMarkerIconLokaler,
                }}
                position={{ lat: latitude, lng: longitude }}
                labelAnchor={new google.maps.Point(121, 164)}
                labelVisible={props.selectedObject.id === marker.get('id')}
                onClick={() => {
                  if (props.selectedObject.id === marker.get('id')) {
                    window.location.href = marker.get('url');
                  } else {
                    props.selectObject(marker.get('id'), true);
                  }
                }}
                noRedraw={true}
                children={
                  <ObjectSearchMapLabel
                    theme={props.theme}
                    selectedObject={props.selectedObject}
                    marker={marker}
                    currentSearchCategory={props.currentSearchCategory}
                  />
                }
              />
            );
          }
        })}
      {props.objectWithSameLocation &&
        props.objectGroupsWithSameLocations &&
        props.objectWithSameLocation.map((marker, index) => {
          let latitude = marker.getIn(['geolocation', 'latitude']);
          let longitude = marker.getIn(['geolocation', 'longitude']);

          if (latitude && longitude) {
            return (
              <Marker
                key={index}
                icon={{ url: TransparentMarker }}
                position={{ lat: latitude, lng: longitude }}
                noRedraw={true}
              />
            );
          }
        })}
    </MarkerClusterer>
  </GoogleMap>
));

class ObjectSearchMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mapHeight: window.innerHeight,
      windowHeight: window.innerHeight,
    };
    this.onResize = this.onResize.bind(this);
    window.addEventListener('resize', this.onResize);
  }

  componentDidMount() {
    this.onResize();
  }

  UNSAFE_componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (this.props.objectData.size || nextProps.objectData.size) &&
      nextProps.objectData !== this.props.objectData
    ) {
      const objectsGroupedByLocation = nextProps.objectData.groupBy((item) => {
        const longitude = item.getIn(['geolocation', 'longitude']);
        const latitude = item.getIn(['geolocation', 'latitude']);
        if (longitude && latitude) {
          return `${longitude}-${latitude}`;
        }
        return null;
      });

      const objectGroupsWithSameLocations =
        (objectsGroupedByLocation.size &&
          objectsGroupedByLocation.filter((group) => group.size > 1)) ||
        Map();
      const objectWithSameLocation =
        (objectGroupsWithSameLocations.size &&
          objectGroupsWithSameLocations
            .map((item) => item.skip(1))
            .toIndexedSeq()
            .flatten(1)) ||
        Map();
      const objectWithUniqueLocation =
        (objectsGroupedByLocation.size &&
          objectsGroupedByLocation
            .filter((group) => group.size === 1)
            .toIndexedSeq()
            .flatten(1)) ||
        Map();

      this.setState({
        objectGroupsWithSameLocations: objectGroupsWithSameLocations,
        objectWithUniqueLocation: objectWithUniqueLocation,
        objectWithSameLocation: objectWithSameLocation,
      });
    }
  }

  onResize() {
    //this.setState({mapHeight: this.refs.searchmap.parentNode.parentNode.clientHeight});
    this.setState({ windowHeight: window.innerHeight });
    this.props.onWindowSizeChanged(document.body.clientWidth);
  }

  render() {
    if (!this.props.renderMap) {
      return null;
    }
    let headerHeight =
      document.querySelector('.mainmenu-container').clientHeight + 1;
    return (
      <div
        className="searchmap"
        ref="searchmap"
        style={{
          height: this.state.windowHeight - headerHeight,
          position: `relative`,
        }}
      >
        <GMap
          objectData={this.props.objectData}
          objectGroupsWithSameLocations={
            this.state.objectGroupsWithSameLocations
          }
          objectWithUniqueLocation={this.state.objectWithUniqueLocation}
          objectWithSameLocation={this.state.objectWithSameLocation}
          onBoundsChanged={this.props.onBoundsChanged}
          center={this.props.center}
          theme={this.props.theme}
          selectObject={this.props.selectObject}
          selectedObject={this.props.selectedObject}
          onZoomChanged={this.props.onZoomChanged}
          currentZoom={this.props.currentZoom}
          currentSearchCategory={this.props.currentSearchCategory}
        />
      </div>
    );
  }
}
ObjectSearchMap.propTypes = {
  center: PropTypes.object,
  onBoundsChanged: PropTypes.func,
  currentSearchCategory: PropTypes.string,
};
ObjectSearchMap.defaultProps = {
  center: { lat: 63.4, lng: 16.8 },
  onBoundsChanged: () => {},
  currentSearchCategory: '',
};
export default ObjectSearchMap;



// WEBPACK FOOTER //
// ./src/js/components/ObjectSearchMap.js